import { Component, Input } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';
import { enumCompanyBusinessType } from '@data-layer/enums/companies';
import { BUSINESS_TYPES } from '@constants/business-types';
import { EnumHintKey } from '@data-layer/enums/common';
import { IItemMask } from '@interfaces/item-mask';

@Component({
  selector: 'company-allow-customs',
  templateUrl: './company-allow-customs.component.html',
  styleUrls: ['./company-allow-customs.component.scss'],
  // TODO: comment for resolving issue with showing validation borders to inputs
  // changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CompanyAllowCustomsComponent {
  @Input() public formGroup: UntypedFormGroup;
  @Input() public isShowDescription: boolean = false;
  @Input() public isOldStyleTheme: boolean = false;
  public aniCbpMask: IItemMask = {
    mask: '000000-00000',
    placeholder: 'YYDDPP-NNNNN',
    inputmode: 'text',
    maskErrorTooltip: 'MASK_ERROR.ANI',
    maskMaxLength: 11,
  } as IItemMask;

  public enumHintKey: typeof EnumHintKey = EnumHintKey;

  public businessTypes: Array<{ value: enumCompanyBusinessType; description: string }> = BUSINESS_TYPES;

  constructor() {}
}
